// @flow
import styled, { css } from "styled-components"
import { center } from "componentsStyled/Shared"
import { mq } from "common/mediaQuery"
import StyledLink from "components/StyledLink"
import { lighten } from "global/theme"

export const ProductTileWrap = styled(StyledLink)`
  padding: 2.8rem 0.5rem;
  height: 31rem;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  margin: -0.1rem;
  background: ${(props) => props.theme.color.white};
  width: 50%;
  max-width: 24rem;
  border: 0.2rem solid #edeef4;
  position: relative;
  outline: none;
  transition: box-shadow 0.25s ease, transform 0.25s ease;

  &:hover {
    transform: translateY(-0.9rem);
    box-shadow: 0 3rem 6rem 0 ${(props) => lighten(
      props.theme.color.primaryText,
      0.2,
    )};
    position: relative;
    z-index: ${(props) => props.theme.zIndices.minimal};
  }

  ${mq.tabletWide} {
    height: 44rem;
  }

  ${p => p.selected &&
  css`
    > * {
      filter: blur(4px);
      position: relative;
      overflow: hidden;
      }
    `}
`;

export const Option = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 1rem;

  [class*=CheckboxWrap] {
    margin-right: 0.5rem;
  }
`

export const ProductModels = styled.div`
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 300ms linear;
  padding: 1rem;

  ${p =>
    p.selected &&
    css`
      position: absolute;
      background-color: rgba(0,0,0,0.5);
      filter: blur(0);
      opacity: 1;
      overflow-y: auto;
    `
  }
`

export const ImageWrap = styled.div`
  flex-grow: 1;
  justify-content: flex-end;
  position: relative;

  img {
    ${center};
    max-height: 100%;
    max-width: 100%;
  }
`

export const Body = styled.div`
  flex-shrink: 0;
  text-align: center;
  margin-top: 3.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/InventorySelector/ProductInventory/ProductInventoryTile/styled.js